import { LocationVarKey } from "@swivl-mono/types";

import { WorksheetColumn, WorksheetLayout, WorksheetRow } from "../../../Components/Worksheets/Layout/Worksheet.Layout.Components";
import { IS_NOT_EQUAL, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { WorksheetComponent, WorksheetComponentType } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.HasVehicleStorage,
  { key: LocationVarKey.HasSmallVehicleStorage, hideIf: IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1") },
  { key: LocationVarKey.HasIndoorVehicleStorage, hideIf: IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1") },
  { key: LocationVarKey.HasOutdoorVehicleStorage, hideIf: IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1") },
  { key: LocationVarKey.HasCoveredVehicleStorage, hideIf: IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1") },
  LocationVarKey.HasRVParking,
  { key: LocationVarKey.HasRVParkingCovered, hideIf: IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1") },
  { key: LocationVarKey.HasRVParkingEnclosed, hideIf: IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1") },
  LocationVarKey.HasTrailerStorage,
  LocationVarKey.HasBusinessStorage,
  LocationVarKey.HasLockers,
  LocationVarKey.HasPOMailbox,
  LocationVarKey.HasWineStorage,
  LocationVarKey.HasBoatStorage
];

export default function LocationSubpageInformation() {
  const page = usePropertiesGetLocationIds();

  return (
    <WorksheetLayout>
      <h4>Storage Types</h4>
      <WorksheetRow>
        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Vehicle Storage"
            keyName={LocationVarKey.HasVehicleStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Small Vehicle"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1")}
            keyName={LocationVarKey.HasSmallVehicleStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Indoor Vehicle"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1")}
            keyName={LocationVarKey.HasIndoorVehicleStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Outdoor Vehicle"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1")}
            keyName={LocationVarKey.HasOutdoorVehicleStorage}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Covered Vehicle"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1")}
            keyName={LocationVarKey.HasCoveredVehicleStorage}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="RV" keyName={LocationVarKey.HasRVParking} />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Covered RV"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1")}
            keyName={LocationVarKey.HasRVParkingCovered}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Enclosed RV"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1")}
            keyName={LocationVarKey.HasRVParkingEnclosed}
          />
        </WorksheetColumn>

        <WorksheetColumn>
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Trailer" keyName={LocationVarKey.HasTrailerStorage} />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Business Storage"
            keyName={LocationVarKey.HasBusinessStorage}
          />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Lockers" keyName={LocationVarKey.HasLockers} />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="PO / Mail Boxes" keyName={LocationVarKey.HasPOMailbox} />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Wine" keyName={LocationVarKey.HasWineStorage} />
          <WorksheetComponent componentType={WorksheetComponentType.SWITCH} {...page} label="Boat" keyName={LocationVarKey.HasBoatStorage} />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Portable Units"
            keyName={LocationVarKey.HasPortableUnits}
          />
        </WorksheetColumn>
      </WorksheetRow>
    </WorksheetLayout>
  );
}
